"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _consts = require("../consts");

var getSpacing = function getSpacing(_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.XXXSMALL, theme.orbit.spaceXXXSmall), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.XXSMALL, theme.orbit.spaceXXSmall), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.XSMALL, theme.orbit.spaceXSmall), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.SMALL, theme.orbit.spaceSmall), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.MEDIUM, theme.orbit.spaceMedium), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.LARGE, theme.orbit.spaceLarge), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.XLARGE, theme.orbit.spaceXLarge), (0, _defineProperty2.default)(_ref2, _consts.SPACINGS.XXLARGE, theme.orbit.spaceXXLarge), _ref2;
};

var _default = getSpacing;
exports.default = _default;